
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { DialogActions, DialogContent, Dialog, Button, Grid } from '@material-ui/core';
import AppBarModal from './AppBarModal'
import { BtnForm } from "./BotonesAccion";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
import moment from 'moment'

class EnviarMensajeFecha extends Component {

  constructor(props) {
    super(props)
    this.state = {
      mensaje: '',
      fecha: null,
    }
    this.fileInput = React.createRef();
  }

  componentDidUpdate({ modal }) {
    let { modal: modalAddNew } = this.props;
    if (modalAddNew !== modal) {
      this.setState({ mensaje: '', fecha: null });
    }
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value
    })
  }


  onSubmit = e => {
    let { mensaje, fecha } = this.state;
    fecha = fecha ? moment(fecha).format('YYYY-MM-DD') : '';
    this.props.enviar(mensaje, fecha);
    e.preventDefault();
  }


  setFechaVisita = (fecha) => {
    this.setState({
      fecha
    })
  }


  render() {
    let { modal, mostrarModal, titulo, label, type, label_fecha,mostrarFecha } = this.props;
    let { mensaje, fecha } = this.state;
    return (
      <div>
        <Dialog open={modal} fullWidth={true} maxWidth="xs" onClose={mostrarModal.bind(this, false)} aria-labelledby="form-dialog-title">
          <AppBarModal titulo={titulo} mostrarModal={mostrarModal} titulo_accion="" accion="" />
          <DialogContent className='scroll'>
            <ValidatorForm onSubmit={this.onSubmit}>
              <Grid container spacing={1} alignItems="flex-end">
              </Grid>
              <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                <TextValidator
                  autoFocus
                  margin="dense"
                  label={label}
                  type={type}
                  fullWidth
                  name="mensaje"
                  value={mensaje}
                  validators={["required"]}
                  errorMessages={["El campo es requerido"]}
                  onChange={this.onChange}
                />
                {
                  mostrarFecha &&
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} >
                    <Grid container>
                      <KeyboardDatePicker
                        required={true}
                        style={{ marginTop: 3, width: '100%' }}
                        minDate={Date("YYYY-MM-dd")}
                        margin="normal"
                        label={label_fecha}
                        format="yyyy-MM-dd"
                        value={fecha}
                        onChange={this.setFechaVisita}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        minDateMessage={`La fecha debe ser mayor que la fecha actual.`}
                        invalidDateMessage='Formato Invalido'
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </Grid>
                }
              </Grid>
              <Button color="primary" type="submit" id='enviar_form_mensaje_fecha' className="oculto"> Enviar </Button>
            </ValidatorForm>
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={() => mostrarModal(false)} />
            <BtnForm texto="ACEPTAR" callback={() => { document.getElementById('enviar_form_mensaje_fecha').click() }} />
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

EnviarMensajeFecha.propTypes = {
  //variables
  modal: PropTypes.bool.isRequired,
  mostrarFecha: PropTypes.bool.isRequired,
  titulo: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  label_fecha: PropTypes.string.isRequired,
  //funciones
  enviar: PropTypes.func.isRequired,
  mostrarModal: PropTypes.func.isRequired,
}

EnviarMensajeFecha.defaultProps = {
  //variables
  mostrarFecha: true,
}


export default EnviarMensajeFecha;
